import { Component } from '@angular/core';
import { SharedService } from '@app/@core/services/shared.service';
import { FacilitiesService } from '@app/@services';
import { FacilityListModel } from '@app/@shared/models/facility.model';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent {
  constructor(private facService: FacilitiesService, private sharedService: SharedService) {

    // kullanıcıya bağlı olan tüm tesisleri çekip servise bağlıyoruz
    this.facService.getFacilityNames().pipe(
      catchError(() => {
        return of(0);
      })).subscribe((res: FacilityListModel[]) => {
        this.sharedService.setFacilities(res);
      });
  }
}
